import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import MUIMenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import MenuItem from './components/MenuItem';

export interface MenuItem {
  label: string;
  icon: IconProp;
  onClick?: () => void;
}

interface Props {
  items: MenuItem[];
}

const MiniBurgerMenu: React.FC<Props> = ({ items }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label='more'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: '400px'
          }
        }}
      >
        {items.map(({ label, icon, onClick = () => null }) => (
          <MUIMenuItem key={label} onClick={onClick}>
            <MenuItem label={label} icon={icon} />
          </MUIMenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MiniBurgerMenu;
